export const isProd = window.location.origin === 'https://tutorial.rye.com';
